import React, { useEffect, useState } from "react";
import styles from "./BusinessDetails.module.scss";
import NavBar from "../navbar/NavBar";
import FilterModal from "../filterConfig/FilterModal";
import dayjs, { Dayjs } from "dayjs";
import {
	dateNow,
	sevenDaysAgo,
	thirtyDaysAgo,
	startOfYear,
	endOfYear,
} from "../../util/datefunction";
import {
	closeLoader,
	openLoader,
} from "../../redux/actions/loader/loaderActions";
import axios from "axios";
import { useDispatch } from "react-redux";
import { openToastAndSetContent } from "../../redux/actions/toast/toastActions";
import {
	BusinessRollingReserveData,
	ColumnRollingReserveData,
} from "../../types/BusinessModule";
import PaginationTable from "../paginatedTable/pagination-table";
import TableHeader from "../TableHeader/TableHeader";
import StatusView from "../StatusView/StatusView";
import { useHistory, useParams } from "react-router-dom";
import { formatTime } from "../../util/timeUtils";
import { numberWithCommas } from "../../util/formatNumber";

function RecentRolling() {
	const { id } = useParams<any>();

	const [tableRow, setTableRow] = useState<any[]>();
	const [businesses, setBusinesses] = useState<any>();
	const [contentAction, setContentAction] = useState<any>({});
	const history = useHistory();

	const dispatch = useDispatch();
	//PAGINATION
	const [pageNumber, setPageNumber] = React.useState<number>(1);
	const [rowsPerPage, setRowsPerPage] = React.useState<number>(100);
	const [nextPage, setNextPage] = useState<number | null>(null);
	const [previousPage, setPreviousPage] = useState<number | null>(null);

	//FILTERING
	const [value, setValue] = useState("");
	const [dropdown, setDropdown] = useState(false);
	const [eventDate, setEventDate] = useState("");
	const [fromDate, setFromDate] = useState<Dayjs | null | string>("");
	const [toDate, setToDate] = useState<Dayjs | null | string>("");
	const [country, setCountry] = useState("");
	const [status, setStatus] = useState("");
	const [email, setEmail] = useState("");

	const [bearer, setBearer] = useState(false);

	const clearHandler = () => {
		setEventDate("");
		setFromDate("");
		setToDate("");
		setCountry("");
		setStatus("");
		setDropdown(false);
		setBearer(true);
	};

	useEffect(() => {
		if (eventDate === "today") {
			setFromDate(dateNow);
			setToDate(dateNow);
		} else if (eventDate === "last7days") {
			setFromDate(sevenDaysAgo);
			setToDate(dateNow);
		} else if (eventDate === "last30days") {
			setFromDate(thirtyDaysAgo);
			setToDate(dateNow);
		} else if (eventDate === "oneyear") {
			setFromDate(startOfYear);
			setToDate(endOfYear);
		} else {
			setFromDate("");
			setToDate("");
		}
	}, [eventDate]);

	const filteredArray = [
		{
			name: "Status",
			value: status,
			setValue: setStatus,
			selective: [{ name: "YES" }, { name: "NO" }],
		},
	];

	const fetchBusinesses = async () => {
		dispatch(openLoader());
		try {
			const data = await axios.get(`/v1/business/${id}/recent/rollingreserve`);
			setBusinesses(data?.data);
			dispatch(closeLoader());
			setBearer(false);
		} catch (error: any) {
			dispatch(closeLoader());
			const message = error?.response?.data?.message;
			dispatch(
				dispatch(
					openToastAndSetContent({
						toastContent: message,
						toastType: "error",
					})
				)
			);
		}
	};

	useEffect(() => {
		fetchBusinesses();
	}, [bearer, value, pageNumber, rowsPerPage]);

	useEffect(() => {
		setPageNumber(businesses?._metadata?.page || 1);
	}, [businesses]);

	const dataBusinesses = () => {
		const tempArr: BusinessRollingReserveData[] = [];
		businesses?.recentReserve
			?.slice(0)
			.reverse()
			.forEach((business: any, index: number) => {
				return tempArr.push({
					rolling_id: business?.id,
					settlement_id: business?.settlement_id,
					amount: business.currency + numberWithCommas(business?.amount),
					currency: business?.currency,
					status: business?.status,
					statusView: (
						<StatusView
							status={business?.status === "reversed" ? "Reversed" : "On Hold"}
							green={"Reversed"}
							orange={"On Hold"}
						/>
					),
					balanceBefore:
						business.currency + numberWithCommas(business?.balanceBefore),
					balanceAfter:
						business.currency + numberWithCommas(business?.balanceAfter),
					merchantcode: business?.merchantcode,
					dateCreated: formatTime(business?.createdat),
					duedate: formatTime(business?.duedate),
				});
			});
		return tempArr;
	};

	useEffect(() => {
		setTableRow(dataBusinesses());
	}, [businesses?.recentReserve]);

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				width: "100%",
				background: "#EFF3F8",
				height: "100%",
				overflowY: "scroll",
			}}
		>
			<NavBar name="Recent Rolling Reserves" />
			<div className={styles.containerBusiness}>
				<div className={styles.containerHeader}>
					<PaginationTable
						data={tableRow ? tableRow : []}
						columns={ColumnRollingReserveData ? ColumnRollingReserveData : []}
						emptyPlaceHolder={
							businesses?.recentReserve == 0 ? "No record found" : "Loading..."
						}
						value={value}
						total={businesses?._metadata?.totalcount}
						totalPage={businesses?._metadata?.pagecount}
						pageNumber={pageNumber}
						setPageNumber={setPageNumber}
						nextPage={nextPage}
						setNextPage={setNextPage}
						previousPage={previousPage}
						setPreviousPage={setPreviousPage}
						rowsPerPage={rowsPerPage}
						setRowsPerPage={setRowsPerPage}
						clickAction={false}
						setContentAction={setContentAction}
					/>
				</div>
			</div>
		</div>
	);
}

export default RecentRolling;
